import { OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { Router } from '@angular/router';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { Store } from '@ngrx/store';
import { ReplaySubject } from 'rxjs';
import { takeUntil, take } from 'rxjs/operators';
import { Selectors, Actions } from 'store/root-reducer';
import { TableNameType, TablePreferenceType } from 'modules/shared/models/table-preference.models';
import { DocumentsService } from 'modules/core/services/documents.service';
import { CustomerService } from 'modules/core/services/customer.service';
import { SnackbarService } from 'app/services/snackbar.service';
var ExpiringDocumentTableComponent = /** @class */ (function () {
    function ExpiringDocumentTableComponent(documentsService, customersService, snackBar, cdRef, router, store) {
        this.documentsService = documentsService;
        this.customersService = customersService;
        this.snackBar = snackBar;
        this.cdRef = cdRef;
        this.router = router;
        this.store = store;
        this.unsubscribe$ = new ReplaySubject(1);
        // Names should be same as used for sorting on the backend
        this.displayedColumns = ['customer', 'document', 'doc_type', 'expiry_date', 'updated_at', 'actions'];
        this.pageSizeOptions = [5, 10, 15];
        this.preferredExpiringDocumentTablePageSize = this.pageSizeOptions[0];
        this.currentPage = 0;
        this.isLoading = false;
        this.isActiveTableTab = 'document';
        this.expiringDocumentsDataSource = new MatTableDataSource([]);
    }
    Object.defineProperty(ExpiringDocumentTableComponent.prototype, "sort", {
        set: function (sort) {
            this.expiringDocumentsDataSource.sort = sort;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ExpiringDocumentTableComponent.prototype, "paginator", {
        set: function (paginator) {
            this.expiringDocumentsDataSource.paginator = paginator;
        },
        enumerable: true,
        configurable: true
    });
    ExpiringDocumentTableComponent.prototype.ngOnInit = function () {
        this.getExpiringDocumentTablePreference();
    };
    ExpiringDocumentTableComponent.prototype.ngOnDestroy = function () {
        this.unsubscribe$.next(null);
        this.unsubscribe$.complete();
    };
    /**
     * Construct api request
     * @method getExpiringDocumentRequest
     */
    ExpiringDocumentTableComponent.prototype.getExpiringDocumentRequest = function () {
        return {
            limit: this.preferredExpiringDocumentTablePageSize,
            offset: this.preferredExpiringDocumentTablePageSize * this.currentPage,
            show_expiry_alerts: true,
            expiring: true,
            sort: this.currentTableSort
        };
    };
    /**
     * Get table preference from store
     * @method getExpiringDocumentTablePreference
     */
    ExpiringDocumentTableComponent.prototype.getExpiringDocumentTablePreference = function () {
        var _this = this;
        this.store.select(Selectors.userPreference.getTablesPreference)
            .pipe(takeUntil(this.unsubscribe$), take(1))
            .subscribe(function (tablesPreference) {
            var tablePreference = tablesPreference[TableNameType.EXPIRING_DOCUMENT_TABLE];
            if (tablePreference) {
                if (tablePreference[TablePreferenceType.PAGE_SIZE]) {
                    _this.preferredExpiringDocumentTablePageSize = tablePreference[TablePreferenceType.PAGE_SIZE];
                }
                if (tablePreference[TablePreferenceType.SORT]) {
                    switch (tablePreference[TablePreferenceType.SORT].direction) {
                        case 'asc':
                            _this.currentTableSort = "" + tablePreference[TablePreferenceType.SORT].active;
                            break;
                        case 'desc':
                            _this.currentTableSort = "-" + tablePreference[TablePreferenceType.SORT].active;
                            break;
                        default:
                            _this.currentTableSort = undefined;
                            break;
                    }
                    _this.expiringDocumentsDataSource.sort.active = tablePreference[TablePreferenceType.SORT].active;
                    _this.expiringDocumentsDataSource.sort.direction = tablePreference[TablePreferenceType.SORT].direction;
                }
            }
            _this.getExpiringDocuments();
        });
    };
    /**
     * Get page with expired documents
     * @method getExpiringDocuments
     */
    ExpiringDocumentTableComponent.prototype.getExpiringDocuments = function (sortPreference) {
        var _this = this;
        this.isLoading = true;
        this.cdRef.detectChanges();
        this.documentsService
            .getDocuments(this.getExpiringDocumentRequest())
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe(function (documentsRes) {
            _this.expiringDocumentsCount = documentsRes.count;
            _this.expiringDocuments = documentsRes.results;
            if (_this.expiringDocumentsDataSource) {
                _this.expiringDocumentsDataSource.data = _this.expiringDocuments;
            }
            else {
                _this.expiringDocumentsDataSource = new MatTableDataSource(_this.expiringDocuments);
            }
            _this.expiringDocumentsDataSource.paginator = _this.paginator;
            _this.isLoading = false;
            _this.cdRef.detectChanges();
        }, function (error) {
            _this.isLoading = false;
            _this.snackBar.error('Error: Failed to load list of expiring documents');
            _this.cdRef.detectChanges();
        });
    };
    /**
     * Dismiss notification about expiring document
     * @method dismissNotification
     */
    ExpiringDocumentTableComponent.prototype.dismissNotification = function (expiringDocument) {
        var _this = this;
        this.isLoading = true;
        this.documentsService
            .toggleNotification(expiringDocument.id, false)
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe(function (documentsRes) {
            _this.snackBar.success('Expiring document notification dismissed');
            _this.getExpiringDocuments();
        }, function (error) {
            _this.snackBar.error('Error: Failed to dismiss expiry document notification');
            _this.isLoading = false;
            _this.cdRef.detectChanges();
        });
    };
    /**
     * Pagination new page event handler
     * @method newTablePageHandler
     */
    ExpiringDocumentTableComponent.prototype.newTablePageHandler = function (event) {
        var _a;
        if (event.pageSize !== this.preferredExpiringDocumentTablePageSize) {
            this.store.dispatch(new Actions.userPreference.SetPaginationPreference((_a = {
                    tableName: TableNameType.EXPIRING_DOCUMENT_TABLE
                },
                _a[TablePreferenceType.PAGE_SIZE] = event.pageSize,
                _a)));
            this.preferredExpiringDocumentTablePageSize = event.pageSize;
        }
        this.currentPage = event.pageIndex;
        this.getExpiringDocuments();
    };
    ExpiringDocumentTableComponent.prototype.sortExpiringDocs = function ($event) {
        var _a;
        this.store.dispatch(new Actions.userPreference.SetSortPreference((_a = {
                tableName: TableNameType.EXPIRING_DOCUMENT_TABLE
            },
            _a[TablePreferenceType.SORT] = {
                active: $event.active,
                direction: $event.direction
            },
            _a)));
        switch ($event.direction) {
            case 'asc':
                this.currentTableSort = "" + $event.active;
                break;
            case 'desc':
                this.currentTableSort = "-" + $event.active;
                break;
            default:
                this.currentTableSort = undefined;
                break;
        }
        this.getExpiringDocuments();
    };
    /**
     * Gets info basing on crps about customer and navigate to the customer
     * @method navigateToCustomer
     */
    ExpiringDocumentTableComponent.prototype.navigateToCustomer = function (expiringDocument) {
        var _this = this;
        this.isLoading = true;
        this.customersService
            .getRelatedCrp(expiringDocument.record.id)
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe(function (crpInfo) {
            var crp = crpInfo.results.find(function (record) { return record.record === expiringDocument.record.id; });
            if (!crp) {
                _this.isLoading = false;
                _this.snackBar.error('Unable to find any CRP related to this document');
                return;
            }
            _this.isLoading = false;
            if (crp.primary) {
                _this.router.navigateByUrl("/customers/" + crp.customer.id + "/edit");
            }
            else {
                _this.router.navigateByUrl("/customers/" + crp.customer.id + "/edit/crp-edit/" + crp.id);
            }
        }, function (error) {
            _this.snackBar.error("Unable to find " + expiringDocument.record.name + " in our database");
            _this.isLoading = false;
            _this.cdRef.detectChanges();
        });
    };
    return ExpiringDocumentTableComponent;
}());
export { ExpiringDocumentTableComponent };
